import React, { useEffect } from 'react';
import { useTitle } from '../hooks/useTitle';
import { LanguageSelector } from '../components/LanguageSelector';
import { AdminBar } from '../components/AdminBar';

export function TermsOfSale() {
  const { setTitle } = useTitle();
  
  useEffect(() => {
    setTitle('Conditions Générales de Vente - Novster AI');
  }, [setTitle]);

  return (
    <div className="min-h-screen bg-white">
      <LanguageSelector />
      <AdminBar />

      <div className="container mx-auto px-4 py-16">
        <h1 className="text-4xl font-bold mb-8">Conditions Générales de Vente</h1>

        <div className="prose max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">1. Objet</h2>
            <p>
              Les présentes Conditions Générales de Vente (CGV) régissent les relations entre
              Novster et ses clients dans le cadre de la fourniture de services de conseil et
              d'accompagnement en intelligence artificielle.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">2. Services</h2>
            <p>
              Novster propose des services de conseil, de formation et d'accompagnement dans
              l'intégration de solutions d'intelligence artificielle, notamment :
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>AI Booster Sprint</li>
              <li>Bootcamp IA</li>
              <li>Accompagnement personnalisé</li>
              <li>Formation sur mesure</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">3. Prix et modalités de paiement</h2>
            <p>
              Les prix des services sont indiqués en euros hors taxes. La TVA applicable sera
              facturée en sus selon les dispositions fiscales en vigueur.
            </p>
            <p>
              Le paiement s'effectue selon les modalités suivantes :
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>30% à la commande</li>
              <li>70% à la livraison</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">4. Durée et résiliation</h2>
            <p>
              La durée des prestations est définie dans le devis ou la proposition commerciale
              acceptée par le client. Toute résiliation anticipée devra faire l'objet d'un
              accord écrit entre les parties.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">5. Propriété intellectuelle</h2>
            <p>
              Tous les droits de propriété intellectuelle sur les livrables produits dans le
              cadre des prestations restent la propriété de Novster jusqu'au paiement complet
              du prix.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">6. Confidentialité</h2>
            <p>
              Chaque partie s'engage à maintenir confidentielles les informations reçues de
              l'autre partie dans le cadre de l'exécution des prestations.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">7. Responsabilité</h2>
            <p>
              Novster s'engage à exécuter ses prestations avec diligence et selon les règles
              de l'art. La responsabilité de Novster ne pourra être engagée qu'en cas de
              faute prouvée.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">8. Force majeure</h2>
            <p>
              Novster ne pourra être tenue responsable de l'inexécution de ses obligations
              en cas de force majeure telle que définie par la jurisprudence française.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">9. Protection des données</h2>
            <p>
              Les données personnelles collectées dans le cadre des prestations font l'objet
              d'un traitement informatique dans le respect du RGPD et de la loi Informatique
              et Libertés.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">10. Droit applicable et juridiction</h2>
            <p>
              Les présentes CGV sont soumises au droit français. Tout litige relatif à leur
              interprétation ou leur exécution relève de la compétence exclusive des
              tribunaux de Paris.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}